import React, { useContext, useState, useEffect } from 'react'
import {
  Container,
  Button2,
  List,
  Container2,
  Title,
  ListBody,
  WrapFooter,
  Button,
  WrapSearch,
  Wrap,
  IconeSearch,
  Header,
  WrapHora,
  Title2,
  Backdrop,
  ModalFechamento,
  BodyTrocarProjeto,
  WrapButtons,
  ModalBox2,
  TitleStyle2,
  Items
} from './styles.js'
import TableFechamento from 'components/TableFechamento'
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,

} from '@material-ui/pickers';
import {
  WrapTotalHoras2,
  Horas,
  TitleHora,
  Hora,
  TotalHoras2
} from '../../components/CommonInfos/styles'
import { createMuiTheme, Modal, CircularProgress, GridList, GridListTile, GridListTileBar, IconButton } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from "@material-ui/styles";
import { useUserResume, useShowModal } from 'contexts/SharedContext'
import { ThemeContext } from 'styled-components'
import { ptBR } from 'date-fns/locale'
import Tooltip from '@material-ui/core/Tooltip';
import { api } from 'services/axios'
import { useSnackbar } from 'notistack';
import { SUCCESSMESSAGE, ERRORMESSAGE, WARNINGMESSAGE } from 'utils/types-messages'
import { GetSessionUser } from 'services/helpers'
import ModalIncluirRegistro from 'components/ModalIncluirRegistro'
import MessageAlert from 'components/MessageAlert'
import { WrapInput } from "../../components/Wrap"
import CancelIcon from '@material-ui/icons/Cancel';
import { CancelarBtn, ConfirmarBtn } from "components/Button";
import { modalClose, StyledBox } from '../../components/Modal';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import UpLoad from 'components/Upload';

export default function FechamentoHoras(props) {
  const { colors, bgHeading, textTableColor } = useContext(ThemeContext)
  const { enqueueSnackbar } = useSnackbar()
  const { setUserResumeFechamento } = useUserResume()
  const { showModalIncluirRegistro } = useShowModal()
  const [showModalFecharPeriodo, setShowModalFecharPeriodo] = useState(false)
  const { userResume } = useUserResume()
  const [buttonDisable, setButtonDisable] = useState(true);
  const [buttonUploadDisable, setButtonUploadDisable] = useState(false);
  const [controle, setControle] = useState(false)
  const [tileData, setTileData] = useState()
  const [dtInicio, setDtInicio] = useState()
  const [dtFim, setDtFim] = useState()

  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      height: '200px',
      marginTop: '30px',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.paper,
    },
    gridList: {
      flexWrap: 'nowrap',
      // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
      transform: 'translateZ(0)',
    },
    title: {
      color: '#FFFFFF',
    },
    titleBar: {
      background:
        'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    table: {
      // minWidth: 650,
      backgroundColor: colors.surface,
      width: '100%',
      fontSize: '14px'
    },
    head: {
      backgroundColor: "#fff",
      position: "sticky",
      top: 0
    },
    headCol: {
      backgroundColor: colors.background,
      position: "sticky",
      top: 0,
      color: textTableColor,
      fontWeight: 500,
      border: 'none',

      textTransform: 'uppercase',
      textAlign: 'center'
    },
    bodyCol: {
      color: textTableColor,
      border: 'none',
      fontSize: '18px',

    },
    wrapBtnModal: {
      alignItems: 'flex-start'
    },
    btnModal: {
      marginLeft: '0', marginTop: '-5px'
    },
    headColModal: {
      backgroundColor: colors.surface,
      textTransform: 'uppercase',
      borderRadius: '0',
      fontSize: '14px'
    },
    containerModal: {
      boxShadow: '0px 4px 0px 0px rgba(0, 0, 0, 0)',
      borderRadius: '0'
    }
  }));

  const classes = useStyles();

  const materialTheme = createMuiTheme({
    overrides: {
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: bgHeading,
        },
      },
      MuiPickersCalendarHeader: {
        switchHeader: {
          //backgroundColor: bgHeading,
          //color: bgHeading,
        },
      },
      MuiPickersDay: {
        day: {
          // color: bgHeading,
        },
        daySelected: {
          backgroundColor: bgHeading,
          '&:hover': {
            backgroundColor: bgHeading,
          },

        },
        dayDisabled: {
          //  color: lightBlue["100"],
        },
        current: {
          color: bgHeading,
        },
      },
      MuiPickersModal: {
        dialogAction: {
          color: bgHeading,
        },
      },
    },
  });

  // <CommonInfos />
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [selectedDateFechamentoInit, setSelectedDateFechamentoInit] = React.useState(null);
  const [selectedDateFechamentoFim, setSelectedDateFechamentoFim] = React.useState(null);
  const [dataSelected, setDataSelected] = useState(new Date())
  const [dataInitSelected, setDataInitSelected] = useState(null)
  const [dataFimSelected, setDataFimSelected] = useState(null)
  const [emailSelected, setEmailSelected] = useState(true);
  const [label, setLabel] = useState('');
  const [hora, setHora] = useState('');
  const [txtStr, setTxtStr] = useState('');
  const [oldRows, setOldRows] = useState([]);
  const [modalArquivos, setModalArquivos] = useState(false);
  const [loadDialog, setLoadDialog] = useState(false);
  const [regDateUpload, setRegDateUpload] = useState('');
  const [diaUpload, setDiaUpload] = useState('');
  const [updateUpload, setUpdateUpload] = useState(false);
  const [personId, SetPersonId] = useState();

  const customControlStyles = base => ({
    ...base,
    height: 35,
    minHeight: 35
  });


  const handleDateChange = (date) => {
    setSelectedDate(date)
    const newDate = new Date(date)
    let mes = newDate.getMonth() + 1
    const ano = newDate.getFullYear()
    if (parseInt(mes) < 10) {
      mes = '0' + mes.toString()
    }
    setDataSelected(ano + '-' + mes);
    setButtonDisable(true);
    setUserResumeFechamento(null);
    setHora('');
  }

  const handleDateFim = (date) => {
    setSelectedDateFechamentoFim(date)
    const newDate = new Date(date)
    let mes = newDate.getMonth() + 1
    let ano = newDate.getFullYear()
    let dia = newDate.getDate()
    if (parseInt(mes) < 10) {
      mes = '0' + mes.toString()
    }
    if (parseInt(dia) < 10) {
      dia = '0' + dia.toString()
    }
    setDataFimSelected(`${ano}-${mes}-${dia}`)
  }

  const handleDateInit = (date,) => {
    setSelectedDateFechamentoInit(date)
    const newDate = new Date(date)
    let mes = newDate.getMonth() + 1
    let ano = newDate.getFullYear()
    let dia = newDate.getDate()
    if (parseInt(mes) < 10) {
      mes = '0' + mes.toString()
    }
    if (parseInt(dia) < 10) {
      dia = '0' + dia.toString()
    }
    setDataInitSelected(`${ano}-${mes}-${dia}`)
  }

  async function handleUpload(event, dia, regDate, update) {
    setModalArquivos(event)

    if (event) {
      setUpdateUpload(update);
      setRegDateUpload(regDate);
      setDiaUpload(dia);
    } else {
      setTileData();
      if (update) {
        getInit();
      }
    }
  }

  const fetchData = () => {
    if (selectedDate !== null) {
      getInit()
    } else {
      enqueueSnackbar(<MessageAlert message='Selecione mês e ano' />, WARNINGMESSAGE)
    }
  };

  useEffect(() => {
    handleDateChange(new Date())
    setUserResumeFechamento(null);
    setHora('');
    setModalArquivos(false);
    getInit()
  }, [])


  useEffect(() => {

  }, [])

  const getInit = async () => {
    try {
      setLoadDialog(true);
      var dtAux = '';
      if (selectedDate === null) {
        const newDate = new Date()
        let mes = newDate.getMonth() + 1
        const ano = newDate.getFullYear()
        if (parseInt(mes) < 10) {
          mes = '0' + mes.toString()
        }
        dtAux = ano + '-' + mes;
      } else {
        dtAux = dataSelected.toString();
      }
      const { perfil } = GetSessionUser()
      SetPersonId(perfil.personId);
      let strAux = 'Eu, ' + perfil.name + ' concordo em enviar por e-mail para a ' + perfil.companyName + ', o meu extrato de horas referente ao período acima.';
      setTxtStr(strAux);
      setLabel(strAux);
      setEmailSelected(true);
      const { data } = await api.get('/registeritem/resumo/' + perfil.personId + '/' + dtAux)
      if (data.success) {
        const { result } = data
        setHora(result.totalMes)
        setUserResumeFechamento(result.dias)
        setButtonDisable(false);
        setDtInicio(result.dias[0].dtIniAux)
        setDtFim(result.dias[0].dtFimAux)
        setLoadDialog(false);
      } else {
        enqueueSnackbar(<MessageAlert message={data.message} />, WARNINGMESSAGE)
        setLoadDialog(false);
      }
    } catch (err) {
      enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE)
      setLoadDialog(false);
    }
  }

  async function fechamento() {
    if (dataInitSelected === null || dataFimSelected === null) {
      enqueueSnackbar(<MessageAlert message='Informe o período.' />, WARNINGMESSAGE)
    } else {
      if (!controle) {
        setControle(true);
        await sendFormFechamento();
        setControle(false);
      }
    }
  }

  async function sendFormFechamento() {
    try {
      setLoadDialog(true);
      const { perfil } = GetSessionUser()
      const obj = {
        fechar: true,
        personId: perfil.personId,
        dtInicial: dataInitSelected,
        dtFinal: dataFimSelected,
        enviarPdf: emailSelected
      }
      const { data } = await api.put('/registeritem/fecharPeriodo', obj)
      if (data.success) {
        enqueueSnackbar(<MessageAlert message={data.message} />, SUCCESSMESSAGE)
        setLoadDialog(false);
        getInit()
      } else {
        enqueueSnackbar(<MessageAlert message={data.message} />, WARNINGMESSAGE)
        setLoadDialog(false);
      }
      setShowModalFecharPeriodo(false)
    } catch (err) {
      enqueueSnackbar(<MessageAlert message={err.message} />, ERRORMESSAGE)
      setLoadDialog(false);
    }
  }

  async function handleFecharPeriodo(evt, opt) {
    setEmailSelected(opt);
    setShowModalFecharPeriodo(evt);
    setSelectedDateFechamentoInit(`${dtInicio}`);
    setSelectedDateFechamentoFim(`${dtFim}`);
    handleDateInit(new Date(`${dtInicio}`))
    handleDateFim(new Date(`${dtFim}`))
  }

  useEffect(() => {

  }, [])

  const modalLoad = (
    <div className={'disabeFocus alert-modal'}>
      <WrapInput style={{ alignItems: 'center' }} className="alertText">
        <CircularProgress style={{ color: '#043D5D' }} /> <h3>Aguarde!</h3>
      </WrapInput>
    </div>
  );

  return (
    <>
      <Container2>
        <big color={colors.textPrimary}>Página Disponível apenas na versão Desktop.</big>
      </Container2>
      <Container>
        <Header>
          <ThemeProvider theme={materialTheme}>
            <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
              <Wrap>
                <Title2>&nbsp;&nbsp;&nbsp;PERÍODO</Title2>
                <WrapSearch>
                  <div></div>
                  <KeyboardDatePicker
                    minDateMessage="Não é possível buscar por datas futuras."
                    views={["month", "year"]}
                    clearable
                    clearLabel="Limpar"
                    cancelLabel="Cancelar"
                    animateYearScrolling

                    margin="normal"
                    placeholder="mês/ano"
                    id="date-picker-dialog"
                    label="Mês Referência"
                    format="MM/yyyy"
                    helperText={''}
                    value={selectedDate}
                    onChange={handleDateChange}
                    minDate={new Date(new Date("01-01-2018"))}
                    maxDate={new Date(new Date())}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                  <Tooltip title="Pesquisar" placement="bottom-end" arrow>
                    <div>
                      <IconeSearch onClick={() => fetchData()}
                        size={25}
                        color="#005A9C" >
                      </IconeSearch>
                    </div>
                  </Tooltip>

                </WrapSearch>
              </Wrap>

            </MuiPickersUtilsProvider>
          </ThemeProvider>

          <WrapTotalHoras2>
            <Title2>&nbsp;&nbsp;&nbsp;TOTAL HORAS MÊS</Title2>
            <TotalHoras2>
              <Horas>
                <Hora> {hora ? hora + 'hs' : '--'}</Hora>
                <TitleHora>trabalhadas</TitleHora>

              </Horas>
            </TotalHoras2>
          </WrapTotalHoras2>


        </Header>

        <List>
          <Title>
            &nbsp;&nbsp; &nbsp;REGISTROS DE HORAS {/* &nbsp; - &nbsp;{userResume.totHorasMes && userResume.totHorasMes} */}
          </Title>
          <ListBody>
            <TableFechamento getInit={getInit} handleUpload={handleUpload} />
          </ListBody>
        </List>
        <WrapFooter>
          {!buttonDisable &&
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
              <Button onClick={buttonDisable !== true ? () => handleFecharPeriodo(true, false) : ''} color="#ddd" marginR="">Fechar Período</Button>&nbsp;&nbsp;
              <Button onClick={buttonDisable !== true ? () => handleFecharPeriodo(true, true) : ''} color="#ddd" marginR="" style={{ backgroundColor: '#3FC248' }}>Enviar Relatório</Button>
            </div>
          }
        </WrapFooter>
        {
          showModalIncluirRegistro && showModalIncluirRegistro.show && <ModalIncluirRegistro regData={showModalIncluirRegistro.regData} />
        }
        {
          showModalFecharPeriodo && <Backdrop onClick={() => setShowModalFecharPeriodo(false)} />
        }

        {
          showModalFecharPeriodo &&
          <ModalFechamento>
            {
              !emailSelected && <Title>&nbsp;&nbsp;&nbsp;&nbsp;FECHAR PERÍODO COMPREENDIDO ENTRE</Title>
            }
            {
              emailSelected && <Title>&nbsp;&nbsp;&nbsp;&nbsp;ENVIAR EMAIL PERÍODO COMPREENDIDO ENTRE</Title>
            }
            <BodyTrocarProjeto>
              <WrapHora>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      minDateMessage="Não é possível buscar por datas futuras."
                      helperText={''}
                      cancelLabel="cancelar"
                      margin="normal"
                      clearLabel="Limpar"
                      clearable
                      id="dateInitial"
                      label="Data Início"
                      format="dd/MM/yyyy"
                      value={selectedDateFechamentoInit}
                      onChange={handleDateInit}
                      minDate={new Date(new Date("01-01-2018"))}
                      maxDate={new Date(new Date())}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      minDateMessage="Não é possível buscar por datas futuras."
                      helperText={''}
                      cancelLabel="cancelar"
                      margin="normal"
                      clearLabel="Limpar"
                      clearable
                      id="dateFinal"
                      label="Data Fim"
                      format="dd/MM/yyyy"
                      value={selectedDateFechamentoFim}
                      onChange={handleDateFim}
                      minDate={new Date(new Date("01-01-2018"))}
                      maxDate={new Date(new Date())}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </WrapHora>
              <WrapButtons>
                <Button2 onClick={() => setShowModalFecharPeriodo(false)} bg="#D12020" >Cancelar</Button2>
                <Button2 onClick={() => fechamento()} className={controle ? 'disable' : 'enable'} bg="#107CB8" >Confirmar</Button2>
              </WrapButtons>
            </BodyTrocarProjeto>
          </ModalFechamento>
        }
        <Modal open={modalArquivos}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <UpLoad personId={personId} dia={diaUpload} regDate={regDateUpload} handleCloseUpload={handleUpload} device={false} btEnviar={false} />
        </Modal>
        <Modal open={loadDialog}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          {modalLoad}
        </Modal>
      </Container >
    </>
  )
}
